export const RESERVATION_SUCCESS_EVENT = 'reservationSuccess';

export interface IReservationSuccessMessage {
    event: typeof RESERVATION_SUCCESS_EVENT;
    restaurantID: string;
    participants: number;
    reservationDate: string;
    reservationTime: string;
}

export const postReservationSuccessMessage = (data: Omit<IReservationSuccessMessage, 'event'>) => {
    const message: IReservationSuccessMessage = {
        event: RESERVATION_SUCCESS_EVENT,
        restaurantID: data.restaurantID,
        participants: data.participants,
        reservationDate: data.reservationDate,
        reservationTime: data.reservationTime,
    };

    window.parent.postMessage(message, '*');
};
